export default "__VITE_ASSET__B_8YkAxE__"